import axios from 'axios';
export const requestOTC = (root, request) => axios.post(`${root}/legacy/change-requests/request-otc`, request).then((r) => r.data);
export const draft = (root, request) => axios.post(`${root}/legacy/change-requests/draft`, request).then((r) => r.data);
export const commit = (root, request) => axios.post(`${root}/legacy/change-requests/commit`, request).then((r) => r.data);
//# sourceMappingURL=change-requests.js.map